module.exports = __webpack_public_path__ + "img/dab_mars.ed8ece3c.jpg";